'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;
// import { asyncConnect } from 'redux-async-connect'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ScreenedCompanies = require('./ScreenedCompanies.css');

var _ScreenedCompanies2 = _interopRequireDefault(_ScreenedCompanies);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _ = require('../');

var _reactSlidedown = require('react-slidedown');

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScreenedCompanies = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.company.result,
    searching: state.company.loading,
    searched: state.company.loaded,
    error: state.company.error
  };
}, searchActions), _dec2 = (0, _reactCssModules2.default)(_ScreenedCompanies2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ScreenedCompanies, _Component);

  function ScreenedCompanies(props) {
    (0, _classCallCheck3.default)(this, ScreenedCompanies);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ScreenedCompanies.__proto__ || (0, _getPrototypeOf2.default)(ScreenedCompanies)).call(this, props));

    _this.clickViewMoreTobacco = function () {
      _this.setState({ viewMoreTobacco: !_this.state.viewMoreTobacco });
    };

    _this.clickViewMoreMedia = function () {
      _this.setState({ viewMoreMedia: !_this.state.viewMoreMedia });
    };

    _this.state = {
      viewMoreTobacco: false,
      viewMoreMedia: false
    };
    return _this;
  }

  (0, _createClass3.default)(ScreenedCompanies, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
      this.props.companies();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.result) {
        var toCompanies = [];
        var tmCompanies = [];
        props.result.map(function (el) {
          if (el.is_to) toCompanies.push(el);
          if (el.is_tm) tmCompanies.push(el);
          return false;
        });
        var _sorter = function _sorter(a, b) {
          var lbl = 'short_name';
          var a_s = a[lbl].toLowerCase();
          var b_s = b[lbl].toLowerCase();
          return a_s.localeCompare(b_s);
        };
        toCompanies = toCompanies.sort(_sorter);
        tmCompanies = tmCompanies.sort(_sorter);
        this.setState({
          toCompanies: toCompanies,
          tmCompanies: tmCompanies
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.result) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '4.0rem' },
            loaded: false
          })
        );
      }

      // else if ( this.props.result && (!this.props.result.fund || !this.props.result.shareClass) ) {
      //   this.context.router.push(config.routes.notFound)
      //   return (
      //     <div styleName='main'>
      //       <Loader
      //         options={{scale: 0.70, top:'2.0rem'}}
      //         loaded={ false }
      //       />
      //     </div>
      //   )
      // }

      var toLabel = !this.state.viewMoreTobacco ? 'View tobacco companies' : 'View less';
      var tmLabel = !this.state.viewMoreMedia ? 'View entertainment studios' : 'View less';
      var toIcon = require('../../../static/images/icon-cigarette.svg');
      var tmIcon = require('../../../static/images/icon-cinema.svg');

      return _react2.default.createElement(
        'div',
        { styleName: 'main-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'company-table-wrapper' },
          _react2.default.createElement(
            'div',
            { styleName: 'company-table-icon-wrap' },
            _react2.default.createElement('img', {
              styleName: 'company-table-icon',
              src: toIcon,
              alt: 'Tobacco companies'
            }),
            _react2.default.createElement(
              'div',
              { styleName: 'company-table-title-to' },
              'Tobacco companies'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'Identified using Morningstar industry categories, these companies either produce tobacco or manufacture tobacco products.'
          ),
          _react2.default.createElement(
            'button',
            {
              styleName: 'company-table-button-to',
              onClick: this.clickViewMoreTobacco,
              title: toLabel
            },
            toLabel,
            _react2.default.createElement(_.LinkIcon, {
              faclass: this.state.viewMoreTobacco ? 'fa-angle-up' : 'fa-angle-down'
            })
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            this.state.viewMoreTobacco ? _react2.default.createElement(
              'table',
              { styleName: 't-table' },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Company'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Symbol'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Legal name'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                this.state.toCompanies.map(function (c, i) {
                  return _react2.default.createElement(
                    'tr',
                    { key: 'to_' + i },
                    _react2.default.createElement(
                      'td',
                      null,
                      c.short_name
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      c.primary_symbol
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      c.legal_name
                    )
                  );
                })
              )
            ) : null
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'company-table-wrapper' },
          _react2.default.createElement(
            'div',
            { styleName: 'company-table-icon-wrap' },
            _react2.default.createElement('img', {
              styleName: 'company-table-icon',
              src: tmIcon,
              alt: 'Entertainment companies'
            }),
            _react2.default.createElement(
              'div',
              { styleName: 'company-table-title-tm' },
              'Entertainment companies'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'Visit our FAQs to learn how we identify tobacco-promoting entertainment companies that promote smoking to kids:\xA0',
            _react2.default.createElement(
              _.Link,
              {
                xstrong: true,
                to: _config2.default.routes.faq + '#2',
                title: 'FAQ: Why entertainment companies?'
              },
              'What do entertainment companies have to do with tobacco?',
              _react2.default.createElement(_.LinkIcon, null)
            )
          ),
          _react2.default.createElement(
            'button',
            {
              styleName: 'company-table-button-tm',
              onClick: this.clickViewMoreMedia,
              title: tmLabel
            },
            tmLabel,
            _react2.default.createElement(_.LinkIcon, {
              faclass: this.state.viewMoreMedia ? 'fa-angle-up' : 'fa-angle-down'
            })
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            this.state.viewMoreMedia ? _react2.default.createElement(
              'table',
              { styleName: 't-table' },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Company'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Symbol'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Legal name'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                this.state.tmCompanies.map(function (c, i) {
                  return _react2.default.createElement(
                    'tr',
                    { key: 'tm_' + i },
                    _react2.default.createElement(
                      'td',
                      null,
                      c.short_name
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      c.primary_symbol
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      c.legal_name
                    )
                  );
                })
              )
            ) : null
          )
        )
      );
    }
  }]);
  return ScreenedCompanies;
}(_react.Component), _class2.propTypes = {
  searching: _react.PropTypes.bool,
  searched: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.array
}, _temp)) || _class) || _class);
exports.default = ScreenedCompanies;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ScreenedCompanies/ScreenedCompanies.js
// module id = 1281
// module chunks = 0